import { api } from "../../utils/api";

export async function getStatusPayment(id) {
  try {
    const response = await api.get(`/statusPayment${id ? `/${id}` : ``}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}